export default "__VITE_ASSET__DHY73qYK__"